export default __webpack_public_path__ + "static/media/home-banner-2.13b83e84.gif";